import { ProjectClusterDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProjectClusterService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getProjectCluster(): Observable<ProjectClusterDto[]> {
    return this.http.get<ProjectClusterDto[]>(this.url + 'project-cluster');
  }

  createProjectCluster(
    data: ProjectClusterDto[]
  ): Observable<ProjectClusterDto[]> {
    return this.http.post<ProjectClusterDto[]>(
      this.url + 'project-cluster',
      data
    );
  }
  getSingleProjectCluster(id: string): Observable<any> {
    return this.http.get(this.url + 'project-cluster/' + id);
  }

  updateProjectCluster(
    data: ProjectClusterDto[]
  ): Observable<ProjectClusterDto[]> {
    return this.http.post<ProjectClusterDto[]>(
      this.url + 'project-cluster/update',
      data
    );
  }

  deleteProjectCluster(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('project-cluster', ids.join(', '));
    return this.http.delete(this.url + 'project-cluster', httpOptions);
  }
}
